export default __webpack_public_path__ + "static/media/edgeLogo.2fa716db.png";